const errors = {
  ConflictError: "api.error.conflict",
  ForbiddenError: "api.error.forbidden",
  NetworkError: "api.error.network_error",
  NotFoundError: "api.error.not_found",
  PaymentRequiredError: "api.error.payment_required",
  ServiceUnavailableError: "api.error.service_unavailable",
  TooManyRequestsError: "api.error.too_many_requests",
  UnauthorizedError: "api.error.unauthorized",
};

export const getErrorTranslation = (error: $TSFixMe) =>
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  errors[error?.name] || "api.error.unknown";

// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
export const isSentry = (error: $TSFixMe) => !errors[error?.name];
